// extracted by mini-css-extract-plugin
export default {"productGallery":"ZK-z","inQuickShop":"_K-z"};